<template>
  <div class="website-news">
    <div class="g-box">
      <div class="news-title">
        <div class="tt">GROUP NEWS</div>
        <div class="tit">
          <div class="name">集团新闻</div>
          <div class="more" @click="toMore">
            more <img class="img" src="../../../assets/img/more2.png" alt="" />
          </div>
        </div>
      </div>
      <div class="news-con">
        <div
          class="item"
          @click="toDetail(item)"
          v-for="item in dataList.slice(0, 4)"
          :key="item.id"
        >
          <div class="item-le">
            <div class="day">{{ item.day.padStart(2, "0") }}</div>
            <div class="year">
              {{ item.year }}.{{ item.month.padStart(2, "0") }}
            </div>
          </div>
          <div class="item-mid">
            <div class="tt">{{ item.subtitle }}</div>
            <div class="tit">
              {{ item.title }}
            </div>
          </div>
          <div class="item-ri">
            <img class="img" src="../../../assets/img/more2.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../../mixins/pageMain_mx";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      dataInfo: {},
      dataList: []
    };
  },
  props: {
    menuId: {
      type: String,
      default: ""
    },
    pageType: {
      type: String,
      default: ""
    }
  },
  components: {},
  async mounted() {
    const dataInfo = await this.getMenuInfo(this.menuId);
    const data = await this.getMenuList2({
      pageNum: 1,
      pageSize: 6,
      menuId: this.menuId
    });

    data.forEach(item => {
      const arr = item.publishTime.split("-");
      item.year = arr[0];
      item.month = arr[1];
      item.day = arr[2];
    });
    this.dataInfo = dataInfo;
    this.dataList = data;
    localStorage.setItem("dataList", JSON.stringify(data));
  },
  methods: {
    toMore() {
      this.toMenu(this.pageType, this.menuId);
    },
    toDetail(item) {
      this.$router.push("/article_details/" + item.id);
    }
  }
};
</script>
<style lang="less">
.website-news {
  height: 620px;
  background: #002fa7;
  box-sizing: border-box;
  .news-title {
    padding-top: 88px;
    .tt {
      font-size: 60px;
      font-family: "en-tit";
      line-height: 72px;
      color: rgba(255, 255, 255, 0);
      -webkit-text-stroke: 1px #fff;
      text-stroke: 1px #fff;
    }
    .tit {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .name {
        font-size: 40px;
        font-family: Dream-LiHeiGB, Dream;
        color: #fff;
        line-height: 45px;
      }
      .more {
        display: flex;
        align-items: center;
        font-size: 24px;
        color: #fff;
        cursor: pointer;
        .img {
          width: 36px;
          height: 36px;
        }
      }
    }
  }
  .news-con {
    padding-top: 60px;
    display: flex;
    flex-wrap: wrap;
    .item {
      margin-right: 40px;
      margin-bottom: 20px;
      padding: 20px;
      display: flex;
      width: 580px;
      height: 120px;
      border: 1px solid rgba(255, 255, 255, 0.2);
      box-sizing: border-box;
      cursor: pointer;
      &-le {
        margin-right: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 80px;
        height: 80px;
        background: rgba(255, 255, 255, 0.1);
        .day {
          font-size: 40px;
          font-family: Roboto-Black, Roboto;
          font-weight: bold;
          color: #fff;
          line-height: 46px;
        }
        .year {
          font-size: 14px;
          font-family: Roboto-Regular, Roboto;
          color: #fff;
          line-height: 16px;
        }
      }
      &-mid {
        flex: 1;
        .tt {
          font-size: 18px;
          font-weight: 500;
          color: #fff;
          line-height: 26px;
        }
        .tit {
          padding-top: 8px;
          width: 360px;
          font-size: 14px;
          color: #fff;
          line-height: 24px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          white-space: normal;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      &-ri {
        display: flex;
        align-items: center;
        .img {
          width: 36px;
          height: 36px;
        }
      }
    }
    .item:hover {
      background: #003fa7;
    }
    .item:nth-child(2n) {
      margin-right: 0;
    }
  }
}
</style>
